/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ClassificationBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1a7 7 0 100 14A7 7 0 008 1zm0 1.441l4.5 2.25v2.924c0 1.283-.384 2.524-1.093 3.518-.743 1.042-2.139 2.058-3.283 2.351l-.112.03-.114-.025c-1.298-.27-2.454-1.163-3.305-2.356-.71-.995-1.093-2.235-1.093-3.518V4.691L8 2.441zm0 1.118l-3.5 1.75v2.306c0 .988.27 1.942.766 2.728l.141.21c.717 1.005 1.675 1.745 2.695 1.958l-.116-.029.075-.021c.815-.273 1.808-.995 2.402-1.737l.13-.171c.586-.822.907-1.86.907-2.938V5.309L8 3.559zM10 5.5a.5.5 0 01.492.41L10.5 6v3a.5.5 0 01-.992.09L9.5 9V6a.5.5 0 01.5-.5z"
        />
    </AccessibleSVG>
);

export default ClassificationBadge16;
